/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationsUpdateRequest = {
  conversationId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  update: components.Update;
};

/** @internal */
export const ConversationsUpdateRequest$inboundSchema: z.ZodType<
  ConversationsUpdateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  conversation_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  update: components.Update$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "conversation_id": "conversationId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ConversationsUpdateRequest$Outbound = {
  conversation_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  update: components.Update$Outbound;
};

/** @internal */
export const ConversationsUpdateRequest$outboundSchema: z.ZodType<
  ConversationsUpdateRequest$Outbound,
  z.ZodTypeDef,
  ConversationsUpdateRequest
> = z.object({
  conversationId: z.string(),
  xOnBehalfOf: z.string().optional(),
  update: components.Update$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    conversationId: "conversation_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function conversationsUpdateRequestToJSON(
  conversationsUpdateRequest: ConversationsUpdateRequest,
): string {
  return JSON.stringify(
    ConversationsUpdateRequest$outboundSchema.parse(conversationsUpdateRequest),
  );
}
export function conversationsUpdateRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConversationsUpdateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConversationsUpdateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationsUpdateRequest' from JSON`,
  );
}
